/**
 * Quiet Luxury Atelier Drop countdown + scroll reveal.
 * mode "until" = chapter open, counts down to next collection (e.g. 1 Sep).
 * mode "opens" = waiting for release.
 */
(function () {
  function nextFirstOfMonth(from) {
    var d = new Date(from.getTime());
    var y = d.getUTCFullYear();
    var m = d.getUTCMonth();
    if (d.getUTCDate() > 1 || d.getUTCHours() > 0 || d.getUTCMinutes() > 0 || d.getUTCSeconds() > 0) {
      m += 1;
      if (m > 11) {
        m = 0;
        y += 1;
      }
    }
    return new Date(Date.UTC(y, m, 1, 0, 0, 0));
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function formatParts(ms) {
    if (ms <= 0) {
      return { days: '00', hours: '00', minutes: '00', seconds: '00', ended: true };
    }
    var total = Math.floor(ms / 1000);
    var days = Math.floor(total / 86400);
    var hours = Math.floor((total % 86400) / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;
    return {
      days: pad(days),
      hours: pad(hours),
      minutes: pad(minutes),
      seconds: pad(seconds),
      ended: false
    };
  }

  function monthLabel(date, locale) {
    try {
      return new Intl.DateTimeFormat(locale || 'en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'Europe/Berlin'
      }).format(date);
    } catch (e) {
      return date.toUTCString();
    }
  }

  function bindReveal(root) {
    var nodes = root.querySelectorAll('[data-ql-reveal]');
    if (!nodes.length) return;
    /* Mobile: skip reveal motion — less jank while snap-scrolling */
    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      window.matchMedia('(max-width: 989px)').matches
    ) {
      nodes.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    nodes.forEach(function (el) {
      io.observe(el);
    });
  }

  function centerSnapRail(rail, force) {
    if (!rail || window.matchMedia('(min-width: 990px)').matches) return;
    if (!force && rail.getAttribute('data-ql-snap-ready') === '1') return;

    var prefer = rail.getAttribute('data-ql-snap-prefer');
    var target = null;
    if (prefer === 'corvo') {
      target = rail.querySelector('.ql-atelier-drop__item--corvo');
    }
    if (!target) {
      var items = rail.querySelectorAll(':scope > .ql-atelier-drop__item, :scope > li');
      if (items.length >= 3) {
        target = items[Math.floor(items.length / 2)];
      } else if (items.length) {
        target = items[0];
      }
    }
    if (!target) return;

    var railRect = rail.getBoundingClientRect();
    var itemRect = target.getBoundingClientRect();
    var delta = itemRect.left + itemRect.width / 2 - (railRect.left + railRect.width / 2);
    if (Math.abs(delta) > 1) {
      rail.scrollLeft += delta;
    }
    rail.setAttribute('data-ql-snap-ready', '1');
  }

  function bindSnapRails(root) {
    var rails = root.querySelectorAll('[data-ql-snap-rail]');
    if (!rails.length) return;
    var lastW = window.innerWidth;

    function recenterAll(force) {
      rails.forEach(function (rail) {
        if (force) rail.removeAttribute('data-ql-snap-ready');
        centerSnapRail(rail, force);
      });
    }

    /* One settle after layout — do not fight the user's finger after that */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        recenterAll(true);
      });
    });
    window.addEventListener(
      'load',
      function () {
        recenterAll(true);
      },
      { once: true }
    );

    /* iOS URL-bar resize must NOT re-center mid-scroll */
    window.addEventListener(
      'resize',
      function () {
        var w = window.innerWidth;
        if (Math.abs(w - lastW) < 50) return;
        lastW = w;
        window.clearTimeout(root._qlSnapResize);
        root._qlSnapResize = window.setTimeout(function () {
          recenterAll(true);
        }, 180);
      },
      { passive: true }
    );
    window.addEventListener('orientationchange', function () {
      lastW = window.innerWidth;
      window.setTimeout(function () {
        lastW = window.innerWidth;
        recenterAll(true);
      }, 220);
    });
  }

  function bind(root) {
    if (!root || root.getAttribute('data-ql-drop-bound') === '1') return;
    root.setAttribute('data-ql-drop-bound', '1');

    bindReveal(root);
    bindSnapRails(root);

    var fixed = root.getAttribute('data-drop-at');
    var mode = root.getAttribute('data-drop-mode') || 'until';
    var locale = root.getAttribute('data-drop-locale') || 'en-GB';
    var labelEl = root.querySelector('[data-drop-label]');
    var openEl = root.querySelector('[data-drop-open]');
    var units = {
      days: root.querySelector('[data-drop-days]'),
      hours: root.querySelector('[data-drop-hours]'),
      minutes: root.querySelector('[data-drop-minutes]'),
      seconds: root.querySelector('[data-drop-seconds]')
    };

    if (!units.days && !labelEl && !openEl) {
      return;
    }

    function targetDate() {
      if (fixed) {
        var parsed = new Date(fixed);
        if (!isNaN(parsed.getTime())) return parsed;
      }
      return nextFirstOfMonth(new Date());
    }

    var lastOpenState = null;
    var lastEnded = null;

    function tick() {
      var target = targetDate();
      var parts = formatParts(target.getTime() - Date.now());
      if (units.days) units.days.textContent = parts.days;
      if (units.hours) units.hours.textContent = parts.hours;
      if (units.minutes) units.minutes.textContent = parts.minutes;
      if (units.seconds) units.seconds.textContent = parts.seconds;

      if (labelEl) {
        if (parts.ended) {
          labelEl.hidden = true;
        } else if (mode === 'until') {
          labelEl.hidden = false;
          labelEl.textContent = 'Until ' + monthLabel(target, locale) + ' · next chapter';
        } else {
          labelEl.hidden = false;
          labelEl.textContent = 'Opens ' + monthLabel(target, locale);
        }
      }

      if (openEl) {
        openEl.hidden = !parts.ended;
        if (parts.ended) {
          if (mode === 'opens') {
            openEl.textContent =
              openEl.getAttribute('data-opened-label') || openEl.getAttribute('data-ended-label') || 'Chapter open';
          } else {
            openEl.textContent = openEl.getAttribute('data-ended-label') || 'Chapter closed · next drop';
          }
        }
      }

      if (lastEnded !== parts.ended) {
        root.classList.toggle('ql-atelier-drop__countdown--ended', parts.ended);
        lastEnded = parts.ended;
      }

      var wantOpen = (mode === 'until' && !parts.ended) || (mode === 'opens' && parts.ended);
      if (lastOpenState !== wantOpen) {
        root.classList.toggle('is-chapter-open', wantOpen);
        lastOpenState = wantOpen;
      }

      var waitlist = root.querySelector('[data-ql-waitlist]');
      if (waitlist) {
        if (mode === 'opens') {
          waitlist.hidden = root.classList.contains('is-chapter-open') && parts.ended;
        } else {
          waitlist.hidden = false;
        }
      }
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('[data-ql-atelier-drop]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
